"use client";

import React from "react";
import { Pagination as AntPagination } from "antd";

import styles from "./Pagination.module.scss";
import classNames from "classnames";
import AntdThemeProvider from "@/app/[lang]/components/AntdThemeProvider";

interface PaginationProps {
  defaultCurrent: number;
  total: number;
  pageSize: number;
  onChange: (pageNumber: number) => void;
  variant?: boolean;
}

export const Pagination = ({
  defaultCurrent,
  total,
  pageSize,
  onChange,
  variant = false,
}: PaginationProps) => {
  return (
    <section
      className={classNames(
        styles.paginationSection,
        variant && styles[variant.toString()]
      )}
    >
      <AntdThemeProvider>
        <AntPagination
          className={styles.pagination}
          defaultCurrent={defaultCurrent}
          total={total}
          pageSize={pageSize}
          onChange={onChange}
        />
      </AntdThemeProvider>
    </section>
  );
};
